import { render, staticRenderFns } from "./Violation.vue?vue&type=template&id=4657274d&scoped=true&"
import script from "./Violation.vue?vue&type=script&lang=js&"
export * from "./Violation.vue?vue&type=script&lang=js&"
import style0 from "./Violation.vue?vue&type=style&index=0&id=4657274d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657274d",
  null
  
)

export default component.exports